module.exports = __webpack_public_path__ + "static/media/1c632593-ea71-42de-b418-30158111ce5f.99a4aad8.JPG";